<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <vxe-button content="button.refresh" icon="vxe-icon-refresh" status="primary" @click="getData"/>
      <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      <vxe-button content="button.save" icon="vxe-icon-save" status="primary" @click="save"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      keep-source
      :edit-rules="editRules"
      :edit-config="editConfig"
      style="margin-top: 2px">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column :cell-render="{name:'VxeSelect',options:inventoryStates}" field="sourceInventoryState" title="business.label.sourceInventoryState"/>
      <vxe-column :cell-render="{name:'VxeSelect',options:inventoryStates}" field="targetInventoryState" title="business.label.targetInventoryState"/>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
  </a-layout>
</template>

<script>
import { findAll, findEnum, saveAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT, WAREHOUSE } from '@/store/mutation-types'
import { InventoryStateSwitchConfig } from '@/api/dto/config/InventoryStateSwitchConfig'

export default {
  name: 'InventoryStateConvertConfig',
  data() {
    return {
      loading: false,
      data: [],
      warehouse: Vue.ls.get(WAREHOUSE),
      contentSize: 0,
      page: 1,
      size: 15,
      inventoryStates: [],
      warehouseData: [],
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815),// 表格竖向滚动条
      editConfig: { trigger: 'click', mode: 'cell', showStatus: true },
      editRules: {
        sourceInventoryState: [
          { required: true, type: 'number', message: '订单类型不能为空' }
        ],
        targetInventoryState: [
          { required: true, type: 'number', message: '库存状态不能为空' }
        ]
      }
    }
  },
  mounted() {
    findEnum('InventoryState').then(res => {
      if (res.success) {
        this.inventoryStates = res.result.map(item => {
          return { label: item.name, value: item.ordinal }
        })
      }
    })
    this.getData()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    add() {
      this.data.push(new InventoryStateSwitchConfig())
    },
    getData() {
      this.loading = true
      findAll('inventoryStateSwitchConfigFactory', {}, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result.map(item => {
            return new InventoryStateSwitchConfig(item)
          })
        }
      }).finally(() => {
        this.loading = false
      })
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords()
      if (saveData.length > 0) {
        this.loading = true
        saveData.forEach(item => {
          item.warehouse = this.warehouse
        })
        saveAll('inventoryStateSwitchConfigPersister', saveData).then(res => {
          if (res.success) {
            this.getData()
            this.$message.success('保存成功')
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    }
  }
}
</script>

<style scoped>
</style>